@if (isVariantC) {
  <app-verified-by-norse-modal-variant-c
    [header]="appCopy.verifiedLogoText"
    [verifiedTitleOne]="appCopy.verifiedTitleOne"
    [verifiedTitleTwo]="appCopy.verifiedTitleTwo"
    [verifiedTitleThree]="appCopy.verifiedTitleThree"
    [verifiedAcknowledgement]="appCopy.verifiedAcknowledgement"
    (closeClick)="onCloseClick()"
  ></app-verified-by-norse-modal-variant-c>
} @else { 
  <div class="modal-header">
    <button
      id="btnClose"
      type="button"
      class="btn-close close"
      aria-label="Close"
      (click)="bsModalRef.hide()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
    <div class="verified-logo color-navy-blue fs-6">
      <div class="text-nowrap">{{ appCopy.verifiedLogoText }} <span class="fa-regular fa-shield-check"></span></div>
      <div><img src="https://assets.flynorse.com/static/site/norse-name-blue.svg" alt="Norse" /></div>
    </div>
  </div>
  <div class="modal-body">
    <div class="verified-items">
      <div class="verified-item"
        [innerHTML]="
        appCopy.verifiedTitleOne | safeHtml: SanitizerValueType.HTML
      "></div>
      <div class="verified-desc"
        [innerHTML]="
          appCopy.verifiedContentOne | safeHtml: SanitizerValueType.HTML
        "
      ></div>
      <div class="verified-item"
        [innerHTML]="
        appCopy.verifiedTitleTwo | safeHtml: SanitizerValueType.HTML
      "></div>
      <div class="verified-desc"
        [innerHTML]="
          appCopy.verifiedContentTwo | safeHtml: SanitizerValueType.HTML
        "
      ></div>
      <div class="verified-item"
        [innerHTML]="
        appCopy.verifiedTitleThree | safeHtml: SanitizerValueType.HTML
      "></div>
      <div class="verified-desc"
        [innerHTML]="
          appCopy.verifiedContentThree | safeHtml: SanitizerValueType.HTML
        "
      ></div>
    </div>
  </div>
  <div class="modal-footer justify-content-center">
    <button class="btn btn-primary verified-cta" (click)="bsModalRef.hide()">
      {{ appCopy.verifiedAcknowledgement }}
    </button>
  </div>
}

